export default "__VITE_ASSET__Dt9IvvaE__"